if (!customElements.get("conditional-announcement")) {
  class ConditionalAnnouncement extends HTMLElement {
    constructor() {
      super();
      this.announcement = this.querySelector("[data-conditional-hours]");
      this.announcementWithinHrs = this.querySelector("[data-within-hours-text]");
      this.announcementOutsideHrs = this.querySelector("[data-outside-hours-text]");
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }
    attachListeners() {
      // Script is deferred; if the page already finished loading (e.g. section re-render), apply now.
      if (document.readyState === "complete") {
        this.handleTimeConditional(this);
        return;
      }
      window.addEventListener("load", function (e) {
        this.handleTimeConditional(this);
      }.bind(this));
    }
    handleTimeConditional() {
      if (!this.announcement || !this.announcementWithinHrs || !this.announcementOutsideHrs) {return}
      const TZ = this.announcement.dataset.timeZone;
      const openHour = Number(this.announcement.dataset.conditionalOpen);
      const closeHour = Number(this.announcement.dataset.conditionalClose);

      const date = new Date();
      const dateInTZ = date.toLocaleString('en-us', {timeZone: TZ });
      const timeInTZ = new Date(dateInTZ).getHours();
      const dayInTZ = new Date(dateInTZ).getDay();

      const isWeekend = dayInTZ === 6 || dayInTZ === 0;
      const isWithinBusinessHours = timeInTZ >= openHour && timeInTZ <= closeHour;
      
      if (!isWeekend && isWithinBusinessHours) {
        this.announcementOutsideHrs.style.display = "none";
      } else {
        this.announcementWithinHrs.style.display = "none";
      }
      
    }
  }
  customElements.define("conditional-announcement", ConditionalAnnouncement);
}